/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CassettePrinter = {
    readonly id?: number;
    readonly lab_id?: number;
    name: string;
    brand?: CassettePrinter.brand;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace CassettePrinter {

    export enum brand {
        DAKEWE = 'dakewe',
        EPREDIA = 'epredia',
    }


}
